import React from "react"
import { withStyles, WithStyles, createStyles } from "@material-ui/core"

import Body from "./Body"
import TriplePhones from "./TriplePhones"

const styles = () => {
  return createStyles({
    root: {
      display: "flex",
      alignItems: "flex-end",
      overflowX: "visible",
      justifyContent: "flex-end",
      marginBottom: "12.1875rem",
    },
  })
}

interface Props extends WithStyles<typeof styles> {}

const WideCallToAction = ({ classes }: Props) => {
  return (
    <section className={classes.root}>
      <TriplePhones />
      <Body />
    </section>
  )
}

export default withStyles(styles)(WideCallToAction)
